import React, { PureComponent } from 'react';
import cx from 'classnames';
import T from 'i18n-react';
import Filter from '../../../../../../components/Filter';
import Sort from './components/Sort';

class SortingAndFiltering extends PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      showFilter: false,
      showSort: false,
    };
    this.handleSortDropdown = this.handleSortDropdown.bind(this);
    this.handleFilterDropdown = this.handleFilterDropdown.bind(this);
  }

  handleFilterDropdown(state) {
    this.setState({ showFilter: state });
  }

  handleSortDropdown(state) {
    this.setState({ showSort: state });
  }

  render() {
    const { showFilter, showSort } = this.state;
    const baseFilterToggleButtonClass = 'isui-filter-sort__show-filter';
    const filterToggleButtonClass = cx(baseFilterToggleButtonClass, {
      'isui-filter-sort__show-filter--open': this.state.showFilter,
    });

    return (
      <div className="SortingAndFiltering">
        <div className="isui-filter-sort">
          <div className="isui-filter-wrapper">
            <span className={filterToggleButtonClass} onClick={() => { this.setState({ showFilter: !this.state.showFilter, showSort: false }); }}>{T.translate('filter.filter')}</span>
          </div>
          <Sort
            disabled={false}
            onLabelClick={() => { this.setState({ showSort: !showSort }); }}
            displaySortDropdown={this.handleSortDropdown}
            isOpen={showSort}
          />
        </div>

        <Filter
          visible={showFilter}
          disabled={false}
          displayFilterDropdown={this.handleFilterDropdown}
          outsideClickIgnoreClass={baseFilterToggleButtonClass}
        />
      </div>
    );
  }
}

SortingAndFiltering.displayName = 'SortingAndFiltering';

export default SortingAndFiltering;
